import React from 'react';
import styles from './persTypesPopup.css';
import { getLetterCodeByNumber } from '../../../../../../../../../../../utils/transformations';
import AddPersonIcon from '../../../../../../../../../../../assets/svg/personAdd.svg';

/**
 *
 * @param answer
 * @returns {JSX.Element}
 * @constructor
 */
export const PersTypesPopup = React.memo( ( { answer } ) => {
    let selectedTypes = '';

    answer.person_types_conformity_answers.map( ( type, index ) => {
        let typeCount = selectedTypes.replace( / /g, '' ).length;

        if ( type.points !== 0 && typeCount < 4 ) {
            selectedTypes = selectedTypes + ' ' + getLetterCodeByNumber( index );
        } else if ( type.points !== 0 && !selectedTypes.includes( '.' ) ) {
            selectedTypes += '..';
        }
    } );

    if ( selectedTypes ) {
        return <span className={ styles.typeText }>{ selectedTypes }</span>;
    } else {
        return <div className={ styles.typeIconWrap }><AddPersonIcon/></div>;
    }
} );